import { LinkPropertyHref } from "vue-meta";
import { settingsService } from "@services/settings.service";

class Service {
  // generates the alternate links from the current route and the global alternate settings
  public fromRoute(route: Route): Array<LinkPropertyHref> {
    const { alternates } = settingsService.options;
    return alternates.map((alternate) => ({
      vmid: "alternate_" + alternate.hreflang,
      rel: "alternate",
      href: alternate.href_base + route?.path?.slice(1), // undefined for jest
      hreflang: alternate.hreflang,
    }));
  }

  // generates the alternate link properties from the given hashmap
  public fromAlternateMap(alternateMap: AlternateUrls): Array<LinkPropertyHref> {
    return Object.entries(alternateMap).map(([key, value]) => ({
      vmid: "alternate_" + key,
      rel: "alternate",
      href: value,
      hreflang: key,
    }));
  }
}

export const alternateService = new Service();
